import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import { post } from '../../helpers/apiHelper';

function EmailVerification() {
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const token = searchParams.get('token');
    const [status, setStatus] = useState('loading'); // 'loading', 'success', 'error'
    const [message, setMessage] = useState('');
    const navigate = useNavigate();

    useEffect(() => {
        const verifyEmail = async () => {
            if (!token) {
                setStatus('error');
                setMessage('No se ha proporcionado un token de verificación.');
                return;
            }

            try {
                const response = await post('auth/verify-email', { token });
                setStatus('success');
                setMessage(response.message || 'Email verificado correctamente');

                // Mostrar mensaje de éxito y redirigir después de 3 segundos
                setTimeout(() => {
                    navigate('/login');
                }, 3000);
            } catch (error) {
                console.error('Email verification failed:', error);
                setStatus('error');
                setMessage(error.message || 'Ha ocurrido un error al verificar el email');
            }
        };

        verifyEmail();
    }, [token, navigate]);

    const renderContent = () => {
        switch (status) {
            case 'loading':
                return (
                    <div className="flex flex-col items-center">
                        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mb-4"></div>
                        <p className="text-gray-600">Verificando tu email...</p>
                    </div>
                );
            case 'success':
                return (
                    <div className="text-center space-y-4">
                        <div className="text-green-500 text-6xl mb-4">✓</div>
                        <h3 className="text-xl font-semibold text-green-600">¡Email Verificado!</h3>
                        <p className="text-gray-600">{message}</p>
                        <p className="text-sm text-gray-500">Serás redirigido al inicio de sesión en unos segundos...</p>
                    </div>
                );
            case 'error':
                return (
                    <div className="text-center space-y-4">
                        <div className="text-red-500 text-6xl mb-4">✕</div>
                        <h3 className="text-xl font-semibold text-red-600">Error de Verificación</h3>
                        <p className="text-gray-600">{message}</p>
                        <button
                            onClick={() => navigate('/login')}
                            className="mt-4 px-4 py-2 bg-primary text-white rounded hover:bg-primary-dark transition-colors"
                        >
                            Ir al Inicio de Sesión
                        </button>
                    </div>
                );
            default:
                return null;
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
            <div className="max-w-md w-full space-y-8 bg-white p-8 rounded-lg shadow-lg">
                <div>
                    <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
                        Verificación de Email
                    </h2>
                </div>
                <div className="mt-8">
                    {renderContent()}
                </div>
            </div>
        </div>
    );
}

export default EmailVerification;
